import { initialState } from "./initialState";
import { assignmentReducer } from "./assignment/assignmentReducer";
import { alertReducer } from "./alert/alertReducer";
import { technicianReducer } from "./technician/technicianReducer";
import {
    manageLabourerReducer,
    manageLabourerSkillsReducer,
    setSelectedLabourerStatus,
    manageLabourerCreateTechnicianErrorReducer,
} from "./manageLabourer/manageLabourerReducer";
import { taskReducer, manageAllStatusReducer } from "./task/taskReducer";
import { tasklistReducer } from "./tasklist/tasklistReducer";
import { loginReducer } from "./login/loginReducer";
import { domainReducer } from "./domain/domainReducer";
import { ganttReducer } from "./gantt/ganttReducer";
import { billingReducer } from "./billing/billingReducer";
import { reasonReducer } from "./reason/reasonReducer";
import { requestNewDueDateReducer } from "./requestDueDate/requestNewDueDateReducer";
import { dashboardReducer } from "./dashboard/dashboardReducer";
import { workorderReducer } from "./workorder/workorderReducer";
import { attachmentsReducer } from "./attachments/attachmentsReducer";
import { followUpsReducer } from "./followUps/followUpsReducer";
import { activityQuestionsReducer } from "./activityQuestions/activityQuestionsReducer";
import { additionalActionReducer } from "./additionalAction/additionalActionReducer";

export const rootReducer = (state = initialState, action) => {
    return {
        assignments: assignmentReducer(state.assignments, action),
        alerts: alertReducer(state.alerts, action),
        technicians: technicianReducer(state.technicians, action),
        contracts: manageLabourerReducer(state.contracts, action),
        allStatus: manageAllStatusReducer(state.allStatus, action),
        skills: manageLabourerSkillsReducer(state.skills, action),
        errors: manageLabourerCreateTechnicianErrorReducer(state.errors, action),
        isSelectedTechnicianEnabled: setSelectedLabourerStatus(state.isSelectedTechnicianEnabled, action),
        tasks: taskReducer(state.tasks, action),
        tasklist: tasklistReducer(state.tasklist, action),
        login: loginReducer(state.login, action),
        domain: domainReducer(state.domain, action),
        gantt: ganttReducer(state.gantt, action),
        billing: billingReducer(state.billing, action),
        reasons: reasonReducer(state.reasons, action),
        requestNewDueDate: requestNewDueDateReducer(state.requestNewDueDate, action),
        dashboard: dashboardReducer(state.dashboard, action),
        workorder: workorderReducer(state.workorder, action),
        attachments: attachmentsReducer(state.attachments, action),
        followUps: followUpsReducer(state.followUps, action),
        additionalActions: additionalActionReducer(state.additionalActions, action),
        activityQuestions: activityQuestionsReducer(state.activityQuestions, action),
    };
};
